<div class="row mb-4">
  <div class="col-12">
    <lib-pauly-checkbox
      [(ngModel)]="showAvailableTo"
      (ngModelChange)="checkboxToggled($event)"
      [label]="checkboxLabel"
      [info]="infoKey ? (infoKey | transloco) : null"
    ></lib-pauly-checkbox>
  </div>
</div>

<div class="row">
  <ng-container [ngTemplateOutlet]="from"></ng-container>
  @if (invertCheckbox ? showAvailableTo : !showAvailableTo) {
    <ng-container [ngTemplateOutlet]="to"></ng-container>
  }
</div>
